import { render, staticRenderFns } from "./JinNangRepo.vue?vue&type=template&id=72485255&scoped=true&"
import script from "./JinNangRepo.vue?vue&type=script&lang=js&"
export * from "./JinNangRepo.vue?vue&type=script&lang=js&"
import style0 from "./JinNangRepo.vue?vue&type=style&index=0&id=72485255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72485255",
  null
  
)

export default component.exports